// 円マークとバリエーション商品時の「~」を付けて整形するというメソッド
export const formatPrice = (price: number, isVariation: boolean) => {
    const formattedPrice = price.toLocaleString('ja-JP',
        {
            style: 'currency',
            currency: 'JPY',
        }
    );
    return isVariation ? formattedPrice + "~": formattedPrice;
}

const priceToNumber = (priceStr: string): number => {
  // ￥1,234,567 => 1234567
  return Number(priceStr.replace(/[￥,]/g, '')) || 0;
}

export const reCalculatePrice = (
  totalPriceElements: HTMLCollectionOf<Element>,
  eachPriceElements: HTMLCollectionOf<Element>) => {

  let sumPrice: number = 0;
  Array.prototype.forEach.call(eachPriceElements, el => {
    if (el.value === '') {
      // o-togetherItems_amountを非表示にする。
      let targetElement = document.getElementsByClassName('o-togetherItems_amount').item(0) as HTMLElement;
      targetElement.style.visibility = 'hidden';
    }
    if (el.checked) {
      sumPrice += priceToNumber(el.value);
    }
  });
  Array.prototype.forEach.call(totalPriceElements, el => {
    // 1234567 => ¥1,234,567
    el.innerHTML = formatPrice(sumPrice, false);
  });
}
